export default __webpack_public_path__ + "static/media/logo.68c7aa4c.png";